@if (customer()?.customerStatus === 'approved') {
    <div class="d-inline-flex align-items-center me-lg-5 me-2">
        @if (customer()?.cashback_amount && customer()!.cashback_amount > 0) {
            <a
                class="border border-highlight rounded d-inline-flex align-items-center gap-2 px-3 my-1 shadow-sm text-highlight text-decoration-none"
                routerLink="wallet-details"
                [queryParams]="{customerInput: json.stringify(customer())}"
                [matTooltip]="'cashback_details.details' | translate"
            >
                <span class="fs-6" aria-hidden="true">💳</span>
                <span class="fw-semibold d-none d-md-inline">{{'dashboard.wallet' | translate}}</span>
                <span class="fw-bold text-highlight">{{customer()?.cashback_amount | number: '1.2': 'it'}}€</span>
            </a>
        } @else {
            <div class="border border-highlight rounded d-inline-flex align-items-center gap-2 px-3 my-1 shadow-sm text-highlight">
                <span class="fs-6" aria-hidden="true">💳</span>
                <span class="fw-semibold d-none d-md-inline">{{'dashboard.wallet' | translate}}</span>
                <span class="fw-bold text-highlight">{{customer()?.cashback_amount | number: '1.2': 'it'}}€</span>
            </div>
        }
    </div>
}